const handleError = (error: Error) => {
  if (error.name !== 'AbortError') {
    console.error('Query failed in onQueryStarted:', error);
  }
};

export const handleQueryLifecycle = async <T>(queryFulfilled: Promise<{ data: T }>, onSuccess: (data: T) => void) => {
  try {
    const { data } = await queryFulfilled;

    if (data) {
      onSuccess(data);
    }
  } catch (error) {
    handleError(error as Error);
  }
};

export function isRtkFetchErrorWithStatus(err: unknown): err is { status: number } {
  return (
    typeof err === 'object' &&
    err !== null &&
    'status' in err &&
    typeof (err as { status: unknown }).status === 'number'
  );
}
